import { Component, input, model } from '@angular/core';
import { UwIcon } from '../icon/uw-icon';

export interface UwTabItem {
  id: string;
  label: string;
  icon?: string;
  count?: number;
}

@Component({
  selector: 'uw-tabs',
  standalone: true,
  imports: [UwIcon],
  template: `
    <div class="flex items-center gap-1 border-b border-line" role="tablist">
      @for (tab of tabs(); track tab.id) {
        <button
          role="tab"
          [attr.aria-selected]="active() === tab.id"
          (click)="active.set(tab.id)"
          class="-mb-px flex items-center gap-1.5 border-b-2 px-3 py-2 text-[12.5px] font-medium transition-colors"
          [class]="
            active() === tab.id
              ? 'border-ai text-ai'
              : 'border-transparent text-secondary hover:text-primary'
          "
        >
          @if (tab.icon) {
            <uw-icon [name]="tab.icon" [size]="14" />
          }
          {{ tab.label }}
          @if (tab.count !== undefined) {
            <span class="rounded-full bg-surface-sunken px-1.5 text-[10px] font-semibold text-secondary">{{ tab.count }}</span>
          }
        </button>
      }
    </div>
  `,
})
export class UwTabs {
  readonly tabs = input.required<UwTabItem[]>();
  readonly active = model<string>('');
}
